
import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IDanhSachThiTotNghiepUpdateLockStatusRequest } from "../../model/request/xet-khoa-luan/IDanhSachThiTotNghiepUpdateLockStatusRequest";
import { IXetKhoaLuanSelectByLopRequest } from "../../model/request/xet-khoa-luan/IXetKhoaLuanSelectByLopRequest";
import { apiClient } from "../apiClient";

const DANH_SACH_THI_TOT_NGHIEP_ENDPOINT = 'danh-sach-thi-tot-nghiep';
export const danhSachThiTotNghiepApi = {
    SelectByLop: (request: IXetKhoaLuanSelectByLopRequest) => apiClient.post(`${DANH_SACH_THI_TOT_NGHIEP_ENDPOINT}/select-lops`, request),
    UpdateLockStatus: (request: IDanhSachThiTotNghiepUpdateLockStatusRequest) => apiClient.patch(`${DANH_SACH_THI_TOT_NGHIEP_ENDPOINT}/locks`, request),
    ChuyenLuanVan: (ids: IIdsRequest) => apiClient.post(`${DANH_SACH_THI_TOT_NGHIEP_ENDPOINT}/chuyen-luan-van`, ids),
}